<div class="list-page kapea" style="max-width: 1300px">
  <app-asiakas-otsikko otsikko="Selaa ostolaskuja" [asiakas]="asiakas()"></app-asiakas-otsikko>

  <form novalidate class="ylaosan-kontrollit">
    <div class="hakukontrollit">
      <mat-form-field>
        <mat-icon matPrefix class="listaus-haku-ikoni">search</mat-icon>
        <mat-label>Etsi</mat-label>
        <input type="text" matInput readonly (click)="avaaHaku()" style="cursor: pointer" [attr.aria-label]="'tositteet.avaa-haku' | translate | async" />
      </mat-form-field>

      <mat-form-field floatPlaceholder="never">
        <mat-label>Tila</mat-label>
        <mat-select [formField]="lomake.tila">
          @for (tv of tilavaihtoehdot; track tv.tunnus) {
            <mat-option [value]="tv.tunnus">{{ tv.nimi }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </form>

  <div style="position: relative">
    <mat-table matSort [dataSource]="dataSource" [matSortDisableClear]="true" style="min-height: 94px">
      <ng-container matColumnDef="paymentStatus">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 130px">Tila</mat-header-cell>
        <mat-cell *matCellDef="let row" style="max-width: 130px" [class]="paymentStatusLuokka(row)">{{ paymentStatusNimi(row.paymentStatus) }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="seller">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Maksunsaaja</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ row.seller || '–' }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="p">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 110px">Laskun pvm</mat-header-cell>
        <mat-cell *matCellDef="let row" style="max-width: 110px">{{ row.invoiceDate ?? row.p | lnumberpvm | async }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="dueDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 110px">Eräpäivä</mat-header-cell>
        <mat-cell *matCellDef="let row" style="max-width: 110px">{{ row.dueDate | lnumberpvm | async }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="paymentDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 110px">Maksun pvm</mat-header-cell>
        <mat-cell *matCellDef="let row" style="max-width: 110px">{{ row.paymentDate | lnumberpvm | async }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="laskunumero">
        <mat-header-cell *matHeaderCellDef style="max-width: 120px">Laskun nro</mat-header-cell>
        <mat-cell *matCellDef="let row" class="mono" style="max-width: 120px">{{ row.laskunumero || '–' }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="sum">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 140px; justify-content: flex-end">Summa</mat-header-cell>
        <mat-cell *matCellDef="let row" style="max-width: 140px; justify-content: flex-end">{{ row.sum ?? row.summa | number: '1.2-2' : 'fi-FI' }} {{ row.currency || 'EUR' }}</mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row (click)="avaa(row)" *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>

    @if ((rivienMaaraObservable | async) === 0 && (lataaObservable | async) === false) {
      <div class="table-ladataan" style="position: absolute; top: 0px; width: 100%; height: 100%; display: flex; justify-items: center; align-items: center">
        <div style="width: 100%; padding-top: 40px; text-align: center; color: #888">Ei ostolaskuja.</div>
      </div>
    }
  </div>

  <mat-paginator [length]="rivienMaaraObservable | async" [pageSize]="20" [pageSizeOptions]="[20, 50, 200]"></mat-paginator>
</div>

<app-tosite-haku [avoinna]="hakuAvoinna" oletusTositelaji="ostolaskut" (suljettu)="suljeHaku()"></app-tosite-haku>
